import { ThreeDots } from "react-loader-spinner";

import { EmptyStateMessage } from "../../../shared/empty-state-message/empty-state-message.tsx";
import type { EmployeeDirectoryCardData } from "../types.ts";
import { EmployeeViewDirectoryCard } from "./employee-view-directory-card.tsx";
import styles from "./employee-view-directory.module.css";

export function EmployeeViewDirectoryGrid({ employees, loading, loadingMore, loadMoreRef, onEmployeeClick }: {
  employees: EmployeeDirectoryCardData[]; loading: boolean; loadingMore: boolean;
  loadMoreRef: (node: HTMLDivElement | null) => void; onEmployeeClick: (employee: EmployeeDirectoryCardData) => void;
}) {
  if (loading) return <div className={styles.centerLoader}><ThreeDots height="56" width="56" color="var(--info)" visible /></div>;
  if (employees.length === 0) return <EmptyStateMessage message="No employees available" />;
  return <>
    <div className={styles.employeeGrid}>{employees.map((employee) => <EmployeeViewDirectoryCard key={String(employee.id)} employee={employee} onClick={() => onEmployeeClick(employee)} />)}</div>
    <div ref={loadMoreRef} className={styles.loadMoreTrigger} aria-hidden />
    {loadingMore ? <div className={styles.moreLoader}><ThreeDots height="40" width="40" color="var(--info)" visible /></div> : null}
  </>;
}
